/* global __CLIENT__ */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';
import { I18nextProvider } from 'react-i18next';
import { renderRoutes } from 'react-router-config';
import qs from 'query-string';

import {
  USER_LNG,
  DEVICE_ID,
} from '@snapask/common-components/dist/constants/cookieNames';
import cookie from '@snapask/common-components/dist/utils/cookie';
import { setBodyLanguage } from '@snapask/common-components/dist/services/language';

import ProviderWithRouter from '@dragonfruit/containers/ProviderWithRouter';
import ReduxAsyncConnect from '@dragonfruit/components/ReduxAsyncConnect';
import mockApi from '@dragonfruit/services/mock';
import config from '@dragonfruit/config';

import i18n from './i18n';
import routes from './routes';
import rootReducer from './redux/reducers';

if (process.env.IS_MOCK) {
  mockApi();
}

if (__CLIENT__) {
  const initialState = {
    ...window.__INITIAL_STATE__,
  };
  const initialI18nStore = window.initialI18nStore || {};
  const initialLanguage = window.initialLanguage;

  const {
    auth: { token, deviceID },
    profile: { data: userData },
  } = initialState;

  const snapCookie = new cookie(config.COOKIE_DOMAIN);

  // set client language cookie. Coconut will feed on to initialize it's language.
  snapCookie.setCookie(USER_LNG, initialLanguage);
  setBodyLanguage(window, initialLanguage);

  // after get app token, need to save to cookie
  const { token: appToken } = qs.parse(location.search);

  if (appToken) {
    snapCookie.setCookie(DEVICE_ID, deviceID);
    snapCookie.updateUserToken(token);
    snapCookie.saveCookieFromAuthInfo(userData);
  }

  // If couldn't retrieve deviceID from Cookies then generate new device id and set a cookie called 'deviceID'
  snapCookie.generateAndSetDeviceId();

  const renderApp = () =>
    // @TODO display errors if rerendering failed
    ReactDOM.hydrate(
      <BrowserRouter>
        <ProviderWithRouter
          initialState={initialState}
          rootReducer={rootReducer}
        >
          <I18nextProvider
            i18n={i18n}
            initialI18nStore={initialI18nStore}
            initialLanguage={initialLanguage}
          >
            <ReduxAsyncConnect
              routes={routes}
              locale={initialLanguage}
              token={token}
            >
              {renderRoutes(routes)}
            </ReduxAsyncConnect>
          </I18nextProvider>
        </ProviderWithRouter>
      </BrowserRouter>,
      document.getElementById('app')
    );

  if (module.hot) {
    module.hot.accept();
    renderApp();
  }

  Loadable.preloadReady().then(() => {
    renderApp();
  });

  // register service worker
  if (process.env.NODE_ENV !== 'local' && 'serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        await navigator.serviceWorker.register('/service-worker.js', {
          scope: '/',
        });
        // only shows for debugging on UAT
        // console.log('Service worker registered!');
      } catch (error) {
        // only shows for debugging on UAT
        // console.log('Error registering service worker: ', error);
      }

      await navigator.serviceWorker.ready;
      // only shows for debugging on UAT
      // console.log('Service Worker Ready');
    });
  }
}



// WEBPACK FOOTER //
// ./app/index.js